import * as React from 'react';
export const SNSvg = React.forwardRef(function SNSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M2.005 2H5v12H2.005C.894 14 0 13.1 0 11.991V4.01A2.01 2.01 0 0 1 2.005 2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M11 2h2.995C15.106 2 16 2.9 16 4.009v7.982A2.008 2.008 0 0 1 13.995 14H11V2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M5 2h6v12H5z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M5 14v-1h6v1H5ZM5 2h6v1H5V2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        fillRule: 'nonzero',
        d: 'm10.296 7.167-1.458.003a.202.202 0 0 1-.193-.14l-.452-1.388a.202.202 0 0 0-.386 0l-.45 1.387a.202.202 0 0 1-.193.14h-1.46a.202.202 0 0 0-.118.368l1.18.857a.202.202 0 0 1 .073.227l-.45 1.388a.202.202 0 0 0 .312.227l1.18-.792a.202.202 0 0 1 .239 0l1.18.792a.202.202 0 0 0 .313-.227L9.161 8.62a.202.202 0 0 1 .074-.227l1.18-.857a.205.205 0 0 0-.12-.37Z',
      }),
    ),
  );
});
SNSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var SN = {
  category: 'flag',
  colorable: false,
  name: 'SN',
  svg: SNSvg,
};
